import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Przykro nam, że artykuł nie był pomocny. Dasz znać, co było nie tak?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Brakuje informacji, których szukam',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Są błędy merytoryczne',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Niektóre kwestie są niejasne',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Daj nam trochę tła i poprawimy ten artykuł.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Wyślij'
    }
  }
};
